import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CloseIcon from '@material-ui/icons/Close';
import {
	Box,
	Chip,
	FormControl,
	TextField,
	Checkbox,
	IconButton,
	InputAdornment
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './FilterForm.style';
import { colors } from 'theme/color-palette';
const { GRAY } = colors;
import styled from 'styled-components';
import { Bogle_Regular } from 'constants/constant';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { deepClone } from 'helper/helper';
import { debounce } from 'helper/helper';
import { UserPortalContext } from 'context/appcontext';
import { getData } from 'service/getData.service';
import APIURLPATH from 'constants/apiconstants';
import open_in_full from 'assets/svgs/open_in_full.svg';

const CustomTextField = styled(TextField)(() => ({
	root: {
		'& .MuiFormHelperText-root': {
			color: GRAY
		}
	},
	label: {
		fontFamily: Bogle_Regular,
		fontSize: 14,
		fontWeight: 400
	}
}));
const icon = <CheckBoxOutlineBlankIcon fontSize="small" style={{ color: '#B2B0B9' }} />;
const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#3C228A' }} />;

function ChipInput({
	cbHandleAddChip,
	cbHandleChipDelete,
	condition,
	value = [],
	dataType,
	index,
	hide,
	customCssStyle,
	placeholder,
	cbHandleOnPaste,
	options = [],
	loading = false,
	chipLen = 0,
	item,
	showExpanded,
	busName
}) {
	const [localVal, setLocalVal] = useState(value);
	const [valueOptions, setValueOptions] = useState(options);
	const [isDropdownOpened, setIsDropdownOpened] = useState(false);
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails } = portalUserContext;
	const { companyName, loginId } = userDetails?.result;
	const request = { companyName, loginId };

	if (hide) {
		return <Box />;
	}
	const classes = styles();
	const getLabel = (option) => {
		if (option === undefined) {
			return '';
		}
		if (typeof option === 'string') {
			return option;
		}
		if (option.deptDesc === undefined) {
			return `${option.deptNum}`;
		}
		return `${option.deptNum} - ${option.deptDesc}`;
	};

	const callApi = async (searchKey) => {
		const techName = item.dbtechnicalName.toLowerCase();
		const URL = `${APIURLPATH.FILTER_VALUES}${techName}?searchKey=${searchKey}`;
		const status = await getData(URL, request);
		if (status.statusCode >= 400) {
			setValueOptions([]);
		} else {
			setValueOptions(status?.json);
		}
	};

	const fetchDropDownValues = debounce((txt) => {
		if (item.filterValuesSearchCall) {
			if (txt.length > 2) {
				callApi(txt);
			} else {
				setValueOptions([]);
			}
		}
	}, 400);

	return (
		<Autocomplete
			style={customCssStyle}
			disabled={condition === ''}
			disableClearable
			value={localVal}
			multiple
			disableCloseOnSelect
			id="tags-filled"
			getOptionLabel={(option) => {
				return getLabel(option);
			}}
			options={valueOptions.map((n) => (n.deptNum ? n : n.toString()))}
			onChange={(e, newval) => {
				if (newval.length > chipLen) {
					return;
				}
				setLocalVal(newval);
			}}
			onClose={(event) => {
				let newList = deepClone(localVal);
				newList = newList.map((el) => (el.deptNum ? el.deptNum : el));
				if (event.target.value.trim().length > 0) {
					newList.push(event.target.value);
				}
				if (newList.length > chipLen) {
					return;
				}
				setIsDropdownOpened(false);
				cbHandleAddChip(event, index, newList);
			}}
			onOpen={() => setIsDropdownOpened(true)}
			renderOption={(option, { selected }) => (
				<React.Fragment>
					<Checkbox
						icon={icon}
						checkedIcon={checkedIcon}
						style={{ marginRight: 8 }}
						checked={selected}
					/>
					{getLabel(option)}
				</React.Fragment>
			)}
			defaultValue={''}
			freeSolo
			renderTags={(value, getTagProps) =>
				value.map((option, idx) => (
					<Chip
						key={idx}
						clickable
						id={`chipInput${idx}`}
						variant="outlined"
						label={getLabel(option)}
						tabIndex="0"
						{...getTagProps({ idx })}
						onDelete={() => {
							let valList = deepClone(localVal);
							valList = valList
								.filter((v) => {
									if (typeof option === 'object') {
										return option.deptNum !== v.deptNum;
									}
									return v !== option;
								})
								.map((v) => (v.deptNum ? v.deptNum : v));
							setLocalVal(valList);
							cbHandleChipDelete(valList, index);
						}}
						deleteIcon={<CloseIcon />}
					/>
				))
			}
			renderInput={(params) => {
				params.InputProps.className = `${params.InputProps.className} ${classes.valueInpHeight}`;
				return (
					<FormControl className={classes.fullWidth}>
						<CustomTextField
							{...params}
							id="chipTxtField"
							variant="outlined"
							label={placeholder}
							autoFocus={true}
							helperText="Delete chips using the delete or backspace key."
							FormHelperTextProps={{ classes: { root: classes.accessibilityOnlyContent } }}
							aria-describedby="my-helper-text"
							type={dataType}
							onKeyDown={(event) => {
								if ([',', 'Enter', 'Tab'].includes(event.key)) {
									let newList = deepClone(localVal);
									newList = newList.map((el) => (el.deptNum ? el.deptNum : el));
									if (event.target.value.length > 0) {
										newList.push(event.target.value);
									}
									if (newList.length > chipLen) {
										return;
									}
									cbHandleAddChip(event, index, newList);
								}

								if (['Backspace'].includes(event.key)) {
									if (event.target.value.length > 0) {
										return;
									}
									let newList = deepClone(localVal);
									newList.pop();
									cbHandleAddChip(event, index, newList);
								}
							}}
							onPaste={(event) => cbHandleOnPaste(event, index, dataType)}
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<>
										{loading ? (
											<CircularProgress color="inherit" size={20} />
										) : dataType === 'number' && localVal.length > 0 && !isDropdownOpened ? (
											<InputAdornment
												position="end"
												style={{ position: 'absolute', bottom: '16px', right: '16px' }}>
												<IconButton
													edge="end"
													id="expand-filter-btn"
													onClick={() => showExpanded(condition, localVal, index, busName)}>
													<img src={open_in_full} />
												</IconButton>
											</InputAdornment>
										) : null}

										{params.InputProps.endAdornment}
									</>
								)
							}}
							onChange={(e) => fetchDropDownValues(e.target.value.trim())}
						/>
					</FormControl>
				);
			}}
		/>
	);
}

ChipInput.propTypes = {
	cbHandleAddChip: PropTypes.func.isRequired,
	cbHandleChipDelete: PropTypes.func.isRequired,
	condition: PropTypes.string.isRequired,
	value: PropTypes.array.isRequired,
	dataType: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	hide: PropTypes.bool,
	customCssStyle: PropTypes.object,
	placeholder: PropTypes.string.isRequired,
	autoFocus: PropTypes.bool
};

export default ChipInput;
